import Cookies from 'js-cookie'
import store from '../store'

const TokenKey = 'Access-Token'
const AccessIdKey = 'Access-Id'

export function getLocalToken () {
  return Cookies.get(TokenKey)
}

export function setLocalToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeLocalToken () {
  return Cookies.remove(TokenKey)
}

export function getLocalAccessId () {
  return Cookies.get(AccessIdKey)
}

export function setLocalAccessId (id) {
  return Cookies.set(AccessIdKey, id)
}

export function removeLocalAccessId () {
  return Cookies.remove(AccessIdKey)
}

export function hasRole (permissionRoles) {
  let roles = store.getters.roles
  if (roles.indexOf('ADMIN') >= 0) return true // admin permission passed directly
  if (!permissionRoles) return true

  let pa = permissionRoles
  if (Object.prototype.toString.call(pa) !== '[object Array]') {
    pa = [permissionRoles]
  }
  return roles.some(role => pa.indexOf(role) >= 0)
}

export function hasAuthority (permissionAuthorities) {
  let roles = store.getters.roles
  if (roles.indexOf('ADMIN') >= 0) return true // admin permission passed directly
  if (!permissionAuthorities) return true

  let pa = permissionAuthorities
  if (Object.prototype.toString.call(pa) !== '[object Array]') {
    pa = [permissionAuthorities]
  }
  let authorities = store.getters.authorities
  return authorities.some(authority => pa.indexOf(authority) >= 0)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js